<template>
  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="col-xl-8 col-lg-10 col-md-12">
        <div class="formation-card-new">

          <!-- Bande latérale -->
          <div class="formation-side">
            <i class="flaticon-education"></i>
          </div>

          <!-- Contenu -->
          <div class="formation-body">
            <h4 class="formation-title-new">Organisation</h4>

            <p class="formation-description">
              Logistique et Préparation pratique (différentes étapes) des diverses activités de l’école.
            </p>

            <!-- <span class="formation-tag">Formation académique</span> -->
          </div>

        </div>
      </div>
    </div>
    <br><br><br>
    <div class="row ">
      <div class="col-xl-4 col-lg-6 col-md-6" v-for="(article, index) in truncatedArticles" :key="index">
          <div class="blog-card style1">
              <div class="blog-img"  :style="{height:'277px', backgroundImage: `url(${getUrlApiForFiles(article.urlImage)})`, backgroundSize: 'cover',backgroundPosition: 'center'}"
              >
              </div>
              <div class="blog-info" style="min-height: 250px;">
                  <ul class="blog-metainfo  list-style">
                      <li><i class="flaticon-user"></i> <router-link to="#">L' École d’Initiation Théologique et Pastorale</router-link></li>
                      <li><i class="flaticon-calendar"></i>{{ format_Date(article.datePublication)  }}</li>
                  </ul>
                  <h3><router-link :to="{ name: 'ViewArticlePage', params: { id: article.id } }">{{ article.titre }}</router-link></h3>
                  <router-link :to="{ name: 'ViewArticlePage', params: { id: article.id } }" class="link style1">Lire plus
                      <i class="flaticon-right-arrow"></i>
                  </router-link>
              </div>
          </div>
      </div>
  </div> 
  </div>
</template>

<script lang="ts">
  
import ApiService from "@/services/ApiService";
import { getUrlApiForFiles, error,format_Date } from "@/utils/utils";
import { defineComponent, ref, onMounted, computed } from "vue";
import { Article } from "@/models/Article";
// import PaginationComponent from '@/components/Utilities/Pagination.vue';

export default defineComponent({
    name: 'ActualitePoste',
  //   components: {
  //     PaginationComponent,

  // },
  setup(){

    const articles = ref<Array<Article>>([]);   

        // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getTreeArticle(page_, limit_);
      } catch (error) {
        //
      }
    };

    function rechercher(){
        getTreeArticle(page.value, limit.value, searchTerm.value );
    }

    // END PAGINATE

    function getTreeArticle(page = 1, limi = 9, searchTerm = '') {
      return ApiService.get(`/actualite/articles/26?page=${page}&limit=${limi}&mot=${searchTerm}&`)
      
      .then(({ data }) => {
        articles.value = data.data.data;
        totalPages.value = data.data.totalPages;
        limit.value = data.data.limit;
        totalElements.value = data.data.totalElements;
      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    } 

    const truncatedArticles = computed(() => {
        const maxLength = 100; 
        return articles.value.map(article => {
            if (article.titre.length > maxLength) {
            return {
                ...article,
                titre: article.titre.substring(0, maxLength) + '...'
            };
            }
            return article;
        });
    });

    // function getTreeArticle() {
    //   return ApiService.get(`/actualite/articles/22`)
    //     .then(({ data }) => {
    //       articles.value = data.data.data;
    //       console.log(articles.value);
    //       return data.data;
    //     })
    //     .catch(({ response }) => {
    //       error(response.message)
    //   });
    // }
    
    onMounted(() => {
        getTreeArticle();
    });

    return { 
        articles,
        getUrlApiForFiles,
        format_Date,
        page, 
        totalPages,
        limit,
        totalElements,
        handlePaginate,
        truncatedArticles
    };
  },
});

</script>

<style scoped>
  .formation-card-new {
  display: flex;
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 12px 35px rgba(11, 27, 63, 0.12);
  overflow: hidden;
  transition: all 0.4s ease;
  height: 100%;
}

.formation-card-new:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 55px rgba(11, 27, 63, 0.25);
}

/* Bande gauche */
.formation-side {
  width: 90px;
  background: linear-gradient(180deg, #0b1b3f, #142a6b);
  display: flex;
  align-items: center;
  justify-content: center;
}

.formation-side i {
  font-size: 42px;
  color: #ffc107;
}

/* Contenu */
.formation-body {
  padding: 28px;
  display: flex;
  flex-direction: column;
}

.formation-title-new {
  font-size: 1.4rem;
  font-weight: 800;
  color: #0b1b3f;
  margin-bottom: 10px;
}

.formation-description {
  font-size: 1.8rem;
  color: #555;
  line-height: 1.6;
  margin-bottom: 16px;
}

.formation-tag {
  align-self: flex-start;
  background: #fff4cc;
  color: #856404;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 6px 14px;
  border-radius: 20px;
}

/* Responsive */
@media (max-width: 768px) {
  .formation-card-new {
    flex-direction: column;
  }

  .formation-side {
    width: 100%;
    height: 80px;
  }
}

</style>